import { render } from "./MediaLibraryModal.vue?vue&type=template&id=1a56ffdc"
import script from "./MediaLibraryModal.vue?vue&type=script&lang=js"
export * from "./MediaLibraryModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1a56ffdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a56ffdc', script)) {
    api.reload('1a56ffdc', script)
  }
  
  module.hot.accept("./MediaLibraryModal.vue?vue&type=template&id=1a56ffdc", () => {
    api.rerender('1a56ffdc', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibraryModal.vue"

export default script